/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HumanToken
 */
export interface HumanToken {
}

/**
 * Check if a given object implements the HumanToken interface.
 */
export function instanceOfHumanToken(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HumanTokenFromJSON(json: any): HumanToken {
    return HumanTokenFromJSONTyped(json, false);
}

export function HumanTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): HumanToken {
    return json;
}

export function HumanTokenToJSON(value?: HumanToken | null): any {
    return value;
}

